import {Api} from '@settings/api'

export const SAVE_SAMPLING_POINTS_PINNED_SECTION_MUTATION_KEY = 'saveSamplingPointsPinnedSection'

type SaveSamplingPointsPinnedSectionParameters = {keyIdentifier: string; value: string}

export async function saveSamplingPointsPinnedSection({
  keyIdentifier,
  value
}: SaveSamplingPointsPinnedSectionParameters): Promise<void> {
  const path = '/distributeduserstorage'
  await Api.axiosInstance.post(path, {keyIdentifier, value})
}
